import React from 'react';
import ContentLayout from '../../../components/ContentLayout';
import props from '../../../lib/contentLayoutProps/admissions/layoutProps';

/* eslint-disable react/prop-types */
export default () => (
  <ContentLayout {...props} locale="en" pageKey="admissions-enquiry">
    <h1>Admissions Enquiry</h1>
    <p>
      Choosing a school for your child is a huge decision. We are glad that you are considering our school. We are happy
      to answer any questions you may have and we do know you probably have many. There are a number of ways for you to
      acquire the information you need.
    </p>
    <p>
      Browse our website. There is a lot of valuable information to be found. We encourage you to come for a tour of the
      school. Kingston holds regular school tours on the first Wednesday of each month at all campuses. School tours at
      the Kindergarten begin at 9:15am and those at the Primary School begin at 10:15am. Parents are welcome to join a
      tour at one campus or visit both campuses. The tour is hosted by a member of the respective campuses Leadership
      Team and are a fantastic way to see the school in action and have your questions answered.
    </p>
    <p>
      Join us for our Open Day which is held every year on a Saturday in November. Dates for the Open Day are published
      on the website prior to the day.
    </p>
    <p>Our Admissions Officers can be reached on 2337 9031 or by email enquiry@kingston.edu.hk</p>
  </ContentLayout>
);
